import * as React from 'react';
import Summaries from './components/views/Summaries';
import styled from '@emotion/styled';
import GuestVMs from './components/views/GuestVMs';
import Tree from './components/views/Tree';
import ToggleIcon from './components/icons/ToggleIcon';
import getFeatureToggle from './feature-toggle/getFeatureToggle';
import { FeatureToggleNames } from './feature-toggle/FeatureToggle.enum';

const Container = styled.div`
  padding: 1rem 0 1rem 0;
`;
const TreeContainer = styled.div`
  padding: 1% 0;
  border: 1px solid #ddd;
  display: inline-block;
  width: ${(s: TreeStyleProps) => (s.showTree ? '25%' : '3%')};
  margin: 1rem 1%;
  background-color: white;
  vertical-align: top;
  font-size: 16px;
  min-height: 80vh;
  overflow: auto;
`;
const MainContainer = styled.div`
  display: inline-block;
  width: ${(s: MainStyleProps) => (s.treeFeatureToggle ? (s.showTree ? '70%' : '92%') : '100%')};
  height: 100%;
  & svg {
    vertical-align: middle;
  }
`;
const IconWrapper = styled.div`
  margin-right: 1rem;
  display: inline-block;
  float: right;
  cursor: pointer;
  line-height: 0;
  padding: 0;
  transform: ${(s: TreeStyleProps) => (s.showTree ? 'rotate(270deg)' : 'rotate(90deg)')};
`;
interface MainStyleProps {
  showTree: boolean;
  treeFeatureToggle: boolean;
}
interface TreeStyleProps {
  showTree: boolean;
}
interface State {
  showTree: boolean;
  treeFeatureToggle: boolean;
}
class App extends React.Component {
  state = {
    showTree: true,
    treeFeatureToggle: false
  } as State;

  toggleTree = () => {
    let showTree = !this.state.showTree;
    this.setState({ showTree });
  };

  async componentDidMount() {
    let treeFeatureToggle = (window as any).Dpack.Toggles[0].Item2;
    this.setState({ treeFeatureToggle });

    // Set any NEW feature toggles here.
      window.ShowNewVirtualCharts = true;
  };

  render() {
    return (
      <>
        {this.state.treeFeatureToggle && (
          <TreeContainer showTree={this.state.showTree}>
            <IconWrapper showTree={this.state.showTree} onClick={() => this.toggleTree()}>
              <ToggleIcon />
            </IconWrapper>
            {this.state.showTree ? <Tree /> : ''}
          </TreeContainer>
        )}

        <MainContainer
          treeFeatureToggle={this.state.treeFeatureToggle}
          showTree={this.state.showTree}
        >
          <Container>
            <Summaries />
          </Container>
          <Container>
            <GuestVMs />
          </Container>
        </MainContainer>
      </>
    );
  }
}

export default App;
